import type {
	MediaEmojiProviderOptions,
	SyncBlockRendererProviderCreator,
} from '@atlaskit/editor-synced-block-provider';
import { EmojiResource } from '@atlaskit/emoji';

import { getEmojiProvider } from '../entry-points/EmojiProvider';
import { createRendererMediaProvider } from '@confluence/fabric-media-support/entry-points/MediaProvider';

export const getSyncedBlockNestedRendererProviderCreator = (
	cloudId: string,
	userId: string | undefined | null,
): SyncBlockRendererProviderCreator => {
	return {
		createEmojiProvider: () => {
			return getEmojiProvider(EmojiResource, {
				cloudId,
				userId: userId || undefined,
				allowAnonymousAccess: true,
			});
		},
		createMediaProvider: ({ contentId: refSyncBlockContentId }: MediaEmojiProviderOptions) => {
			return createRendererMediaProvider({
				contentId: refSyncBlockContentId,
				isExternalShare: false,
			});
		},
	};
};
